import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 24px 0;
`;

export const Row = styled.div`
  display: flex;
  & > div {
    margin-right: 12px;
  }

  [class*=" cl-"] {
    margin-right: 8px;
    font-size: 14px;
  }
`;

export const UnitsCount = styled.div`
  margin-top: 14px;
`;
